import * as React from 'react'
import { ColumnHeadline } from './Shared'
import { breakpoint, styled } from '../../../../shared/styled-components'
import { OfferInstance } from '../../../../models/Offer'
import { Utils } from '../../../../shared/Utils'
import { CodeBadge } from './CodeBadge'

export const Costs = ({ offer }: { offer: OfferInstance }) => {
  return (
    <Container>
      <ColumnHeadline>Kosten für Ihre Implantatversorgung</ColumnHeadline>
      <Result>
        <ResultLabel>Ergebnis:</ResultLabel>
        <ResultValue>{Utils.formatAmount(offer.selfExpense)} &euro;</ResultValue>
      </Result>
      <Financing>Finanzierungsrate: {Utils.formatAmount(offer.selfExpense / 24, 2)} &euro;</Financing>
      <Bottom>
        <Prices>
          <tbody>
            <PriceRow>
              <PriceLabel>Gesamtpreis:</PriceLabel>
              <PriceValue>{Utils.formatAmount(offer.costs)} &euro;</PriceValue>
            </PriceRow>
            <PriceRow>
              <PriceLabel>Zuschuss:</PriceLabel>
              <PriceValue>- {Utils.formatAmount(offer.allowance)} &euro;</PriceValue>
            </PriceRow>
            <PriceRow>
              <PriceLabel>Ihr Eigenanteil:</PriceLabel>
              <PriceValue>{Utils.formatAmount(offer.selfExpense)} &euro;</PriceValue>
            </PriceRow>
          </tbody>
        </Prices>
        <PriceNotice>
          Bitte beachten Sie, dass dieser Preis auf Ihren Angaben beruht und nur eine Schätzung ist. Der genaue
          Behandlungspreis kann abweichen.
        </PriceNotice>
        <MobileCodeBadgeContainer>
          <CodeBadge offer={offer} />
        </MobileCodeBadgeContainer>
      </Bottom>
    </Container>
  )
}

const Container = styled.div`
  margin-bottom: 4rem;
  padding-top: 2rem;
@media (max-width: 950px) {
    padding: 20px;
    margin-bottom: 0;
  }
@media (max-width: 600px) {
    padding: 20px 20px 0 20px;
  }
`

const Result = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  padding-top: 10px;
`

const ResultLabel = styled.span`
  font-weight: bold;
  font-size: 20px;
`

const ResultValue = styled.span`
  color: ${(props) => props.theme.greenColor};
  font-size: 35px;
  padding-left: 10px;
  margin-bottom: -5px;
`

const Financing = styled.div`
  font-size: 14px;
  padding-bottom: 10px;
`

const Bottom = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  @media (max-width: 600px) {
    flex-direction: column;
    align-items: start;
  }
`

const Prices = styled.table`
  flex: 1;
  @media print { 
  max-width: 50%
  }
`

const PriceRow = styled.tr``

const PriceLabel = styled.td``

const PriceValue = styled.td`
  color: ${(props) => props.theme.greenColor};
`

const PriceNotice = styled.div`
  border-radius: 3px;
  padding: 5px;
  background: ${(props) => props.theme.blueColor};
  color: white;
  font-size: 9px;
  flex: 0 0 40%;
  display: none;
  ${breakpoint('tablet')`
    display: block;
  `};
`

const MobileCodeBadgeContainer = styled.div`
  display: block;
  ${breakpoint('tablet')`
    display: none;
  `};
`
